/**
 * Duration (in milliseconds) for the snippet drawer slide animation.
 */
export const SNIPPET_DRAWER_SLIDE_DURATION = 500;
